import { SVGProps } from "react";

export default function ArrowRightDiamondIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 12, width = 31, stroke = "black", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 31 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M30.043 5.77344L24.2695 -6.53267e-05L18.496 5.77344L24.2695 11.5469L30.043 5.77344ZM0 5.77344V6.77344H24.2695V5.77344V4.77344H0V5.77344Z"
        fill={stroke}
      />
    </svg>
  );
}
